class Tracking {
    constructor(element) {
        this.element = element;
        this.trackingConfigs = [
            { selector: '[data-tracking-item]', dataAttr: 'trackingItem', logLabel: 'select_item' },
            { selector: '[data-tracking-item-add]', dataAttr: 'trackingItemAdd', logLabel: 'add_to_cart' },
            { selector: '[data-tracking-cart-decrease]', dataAttr: 'trackingCartDecrease', logLabel: 'remove_from_cart (decrease)' },
            { selector: '[data-tracking-remove-from-cart]', dataAttr: 'trackingRemoveFromCart', logLabel: 'remove_from_cart (delete)' },
        ];
    }

    initialize() {
        // console.log('Tracking initialized for product ID:', this.element.dataset.productId);
        this.trackingConfigs.forEach(config => this.setupTracking(config));
    }

    setupTracking({ selector, dataAttr, logLabel }) {
        const trackingElement = this.element.querySelector(selector);
        if (!trackingElement || !trackingElement.dataset[dataAttr]) return;

        trackingElement.addEventListener('click', () => {
            try {
                const data = JSON.parse(trackingElement.dataset[dataAttr]);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push(data);
                // console.log(`Tracking: ${logLabel}`, data);
            } catch (e) {
                console.warn(`Tracking: error in parsing ${dataAttr}`, e);
            }
        });
    }
}

export { Tracking };